import { styled } from "styled-components";

export const FooterComponent = styled.footer`
  padding: 60px 0;
  border-top: 1px solid #dfdfdf;
  @media all and (max-width: 768px) {
    padding: 5.208vw 0;
  }
`;

export const FooterContentWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  @media all and (max-width: 768px) {
    gap: 5.208vw;
  }
`;

export const FooterLogo = styled.h1`
  img {
    width: 124px;
    height: 104px;
  }
  @media all and (max-width: 768px) {
    img {
      width: 17.448vw;
      height: 13.672vw;
    }
  }
`;

export const FooterTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    text-align: left;
    h6 {
      font-size: 16px;
      color: #242424;
      font-weight: bold;
    }
    p {
      font-size: 14px;
      color: #242424;
    }
  }
  > span {
    text-align: left;
    color: #242424;
    font-size: 14px;
    line-height: 1.4;
  }
  @media all and (max-width: 768px) {
    gap: 2.604vw;
    > div {
      gap: 0.911vw;
      h6 {
        font-size: 3.385vw;
      }
      p {
        font-size: 3.125vw;
      }
    }
    > span {
      font-size: 2.604vw;
    }
  }
`;
